export default __webpack_public_path__ + "static/media/elina@2x.d78dde5f.png";